import request from '@/utils/request'

/**
 * 认证相关接口
 */

// 登录
export function login(data) {
  return request.post('/admin/auth/login', data)
}

// 登出
export function logout() {
  return request.post('/logout')
}

// 获取当前用户信息
// 后端接口: GET /admin/auth/me
// request.js 已自动处理 code === 0 并返回 data，所以这里直接得到用户对象
export function getCurrentUser() {
  return request.get('/admin/auth/me')
}

